import { SyntheticEvent, memo } from "react";
import {
  Form,
  FormGroup,
  FormField,
  Icon,
} from "semantic-ui-react";

// Serializers
import BroadcastPostSerializer from "@/issara-sdk/types/BroadcastPostSerializer_apps_PRX";
import EmployeeSerializer from "@/issara-sdk/types/EmployeeSerializer_users";

// Interfaces
import { ICONS } from "./sequence/MeForm";

// Utils
import { formatISOtoBEDateTime } from "react-lib/utils/dateUtils";
import { UpdatedUserFirebase } from "./MeFormType";

type ModInReviewContentProps = {
  // func
  // onClose: () => void;
  // onBack: () => void; // go back to broadcast list (MeCast Menu)

  // data
  broadcastDetail?: BroadcastPostSerializer;
  // createdByUser?: EmployeeSerializer;
  updatedByUserFirebase?: UpdatedUserFirebase;
};

const ModInReviewContent = (props: ModInReviewContentProps) => {
  return (
    <>
      <Form style={{ backgroundColor: "var(--primary-select-background)" }}>
        <FormGroup inline style={{ padding: "10px 10px 0px 10px" }}>
          <FormField width={2} style={{ display: "flex", justifyContent: "center" }}>
            <img
              src={ICONS.inPreview}
              height="30px"
              width="30px"
            />
          </FormField>
          <FormField width={14} style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                fontSize: 16,
                lineHeight: 1.5,
                fontWeight: "bold"
              }}
            >
              <label>This content is currently under review to ensure</label>
              <label>compliance and suitability prior to publishing.</label>
            </div>
          </FormField>
        </FormGroup>
        <FormGroup inline style={{ paddingBottom: "10px" }}>
          <FormField width={2}>
            <></>
          </FormField>
          <FormField width={14} style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                lineHeight: 1.5,
                color: "#C80035"
              }}
            >
              <label>If the review exceeds the scheduled time,</label>
              <label>it will be sent immediately once approved.</label>
            </div>
          </FormField>
        </FormGroup>
      </Form>

      <Form style={{ marginTop: 8 }}>
        <FormGroup inline>
          <FormField width={16} inline style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Icon name="send" style={{ color: "var(--primary-theme-color)" }} />
              <label>
                <span style={{ fontWeight: "bold" }}>
                  {`Created by: `}
                </span>
                {props.updatedByUserFirebase?.name || ""}
              </label>
            </div>

            <label style={{ fontStyle: "italic", fontWeight: "normal" }}>
              {formatISOtoBEDateTime(props.broadcastDetail?.edited_at).dateTimeShortBracket}
            </label>
          </FormField>
        </FormGroup>
      </Form>
    </>
  );
};

ModInReviewContent.displayName = "ModInReviewContent";

export default memo(ModInReviewContent);